import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/style/animation.main.less'
import '@/style/style.main.less'
import 'view-design/dist/styles/iview.css';
Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
